export default "__VITE_ASSET__C8NA_7Ac__"